var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{domProps:{"value":_vm.theme},on:{"change":_vm.change}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$t("settings.themes.light")))]),_c('option',{attrs:{"value":"dark"}},[_vm._v(_vm._s(_vm.$t("settings.themes.dark")))])])}
var staticRenderFns = []

export { render, staticRenderFns }